import APIController from '../core-api-controller';

export const fetchCheckoutSessionsApi = (paramsObj = {}, paramsStr = '') => {
  const path = `${APIController.endpointApi}/checkout_sessions${paramsStr ? paramsStr : ''}`;
  return APIController.getApiCallback(path, paramsObj);
};

export const expireCheckoutSessionApi = (id = '') => {
  const path = `${APIController.endpointApi}/checkout_sessions/${id}/expire`;
  return APIController.postCallback(path);
};
